const doc = [({"ja":({"buttonBookingActivity":({"cancelBookingPlan":"このプランの予約をキャンセル", "cancelBookingRoom":"この体験の予約をキャンセル"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;